import CONTENT from '../../DOM/content/CONTENT.js';
import EL from '../../EL/EL.js';
import CITE from '../../DOM/cite/CITE.js';
import PRE, { text } from '../../DOM/pre/PRE.js';
import STRING from '../../../STRING.js';
import { HTMLELEMENT } from '../../../enums/HTMLELEMENT.js';
// import mermaid from 'node_modules/mermaid/dist/mermaid.js';
// import mermaid from 'mermaid';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { code } from '../../DOM/code/CODE.js';
// Model Structure
export const diagramAttr = makeAttrStruct([]);
export const diagramData = makeDataStruct([
    ['code'],
    ['cite']
]);
export const diagramModel = makeStruct([
    ['attributes', diagramAttr],
    ['data', diagramData]
]);
// Simplified Model
export function diagram(language, codeText, cite = '') {
    return diagramModel(diagramAttr(), diagramData(code(language, codeText), text(cite)));
}
/** Displays a mermaid-formatted diagram using markdown syntax
    @see https://mermaid.js.org/intro/
*/
export default class DIAGRAM extends CONTENT {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('diagram');
        this.pre = new PRE(this, model.data.code); //'mermaid'
        this.cite = new CITE(this, model.data.cite);
        // mermaid.run({ nodes: [this.pre.el] });
    }
}
export { CITE, EL, PRE, STRING };
